const KEY = 'rk-bookmarks-v1';
const CHANGE_EVENT = 'rk-bookmarks-changed';

function readAll() {
  try {
    const raw = localStorage.getItem(KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

function writeAll(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, 40)));
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(CHANGE_EVENT));
    }
  } catch {
    /* ignore */
  }
}

export function listBookmarks() {
  return readAll();
}

export function isBookmarked(storyId) {
  if (storyId == null) return false;
  return readAll().some((b) => String(b.id) === String(storyId));
}

export function toggleBookmark(story) {
  if (!story?.id) return false;
  const list = readAll();
  const id = String(story.id);
  const idx = list.findIndex((b) => String(b.id) === id);
  if (idx >= 0) {
    list.splice(idx, 1);
    writeAll(list);
    return false;
  }
  list.unshift({
    id: story.id,
    title: story.title || '',
    titleEn: story.titleEn || '',
    cover: story.cardImage || story.image || '',
    savedAt: Date.now(),
  });
  writeAll(list);
  return true;
}

export function removeBookmark(storyId) {
  writeAll(readAll().filter((b) => String(b.id) !== String(storyId)));
}
